export default __webpack_public_path__ + "static/media/img_baseCottonBunnyEars_flowers.c035c113.jpg";